import { gql, useQuery, ApolloError } from '@apollo/client'

const GET_WORKSPACE_COOKIE_FROM_ELEMENT = gql`
  query GetWorkspaceCookieFromElement($elementId: ID!) {
    workspaceCookieFromElement(elementId: $elementId) {
      workspaceId
    }
  }
`

const GET_WORKSPACE_BY_ID = gql`
  query GetWorkspaceById($workspaceId: ID!) {
    workspace(id: $workspaceId) {
      id
      slug
      user {
        id
        subscriptionPlan {
          code
        }
      }
    }
  }
`

export interface Workspace {
  id: string
  slug?: string
  user?: {
    id: string
    subscriptionPlan?: {
      code: string
    } | null
  } | null
}

export interface UseWorkspaceFromElementResult {
  workspace?: Workspace | null
  loading: boolean
  error?: ApolloError | null
  refetch?: (() => Promise<any>) | undefined
}

export default function useWorkspaceFromElement(
  elementId?: string | null
): UseWorkspaceFromElementResult {
  const {
    data: cookieData,
    loading: cookieLoading,
    error: cookieError,
  } = useQuery(GET_WORKSPACE_COOKIE_FROM_ELEMENT, {
    variables: { elementId },
    skip: !elementId,
    fetchPolicy: 'cache-first',
  })

  const workspaceId = cookieData?.workspaceCookieFromElement?.workspaceId

  const {
    data: workspaceData,
    loading: workspaceLoading,
    error: workspaceError,
    refetch,
  } = useQuery(GET_WORKSPACE_BY_ID, {
    variables: { workspaceId },
    skip: !workspaceId,
    fetchPolicy: 'cache-first',
  })

  const loading = Boolean(cookieLoading || workspaceLoading)
  const error = (cookieError ?? workspaceError) || null
  const workspace = workspaceData?.workspace ?? null

  return { workspace, loading, error, refetch }
}

export { GET_WORKSPACE_BY_ID, GET_WORKSPACE_COOKIE_FROM_ELEMENT }
